export default [
    {
        text: 'ID',
        value: 'id',
    },
    {
        text: 'cod interno',
        value: 'internal_code',
    },
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'alias',
        value: 'alias_name',
    },
    {
        text: 'vendible',
        value: 'is_salable',
        format: 'boolean',
    },
    {
        text: 'stock crítico',
        value: 'criticalStockItem',
        format: 'number',
    },
    {
        text: 'precio costo',
        value: 'costPriceItem',
        format: 'currency',
    },
    {
        text: 'precio venta',
        value: 'salePriceItem',
        format: 'currency',
    },
    {
        text: 'margen',
        value: 'marginItem',
    },
]
